import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import moment from "moment";
import _ from "lodash";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

class Text extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advance: false,
      text: props.canvas.message,
      title: props.canvas.title,
      locationText: props.canvas.locationText
    };
    this.copyToCanvas = _.debounce(() => {
      this.props.setCanvas({
        ...this.props.canvas,
        message: this.state.text,
        title: this.state.title,
        locationText: this.state.locationText
      });
    }, 500);
  }

  copyToCanvas() {
    this.copyToCanvas.cancel();
    this.copyToCanvas();
  }

  render() {
    return (
      <div className="text-options">
        <div className="info">
          <p>What is your custom message?</p>
        </div>

        <div className="text-row">
          <textarea
            rows={"4"}
            value={this.state.text}
            onChange={e => {
              let lines = e.target.value.match(/.{1,35}/g);
              if (lines) {
                if (lines.length > 4) {
                  return;
                }
              }

              this.setState({
                text: e.target.value
              });
              this.copyToCanvas();

              // this.props.setCanvas({
              //   ...this.props.canvas,
              //   message: e.target.value
              // });
            }}
          />
          <span className="lines">4 lines allowed</span>
        </div>

        <div
          className="advanced"
          onClick={() => {
            this.setState({ advance: !this.state.advance });
          }}
        >
          <span>Advanced Options</span>
        </div>

        {this.state.advance && (
          <div>
            <div className="text-row">
              <span>Title</span>
              <input
                type="text"
                value={this.state.title}
                onChange={e => {
                  // this.props.setCanvas({
                  //   ...this.props.canvas,
                  //   title: e.target.value
                  // });

                  this.setState({
                    title: e.target.value
                  });
                  this.copyToCanvas();
                }}
              />
            </div>
            <div className="text-row">
              <span>Location Text</span>
              <input
                type="text"
                value={this.state.locationText}
                onChange={e => {
                  // this.props.setCanvas({
                  //   ...this.props.canvas,
                  //   locationText: e.target.value
                  // });
                  this.setState({
                    locationText: e.target.value
                  });
                  this.copyToCanvas();
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Text);

export default App;



// WEBPACK FOOTER //
// ./src/components/Text/index.js